import { render, staticRenderFns } from "./Aba.vue?vue&type=template&id=533f2971"
import script from "./Aba.vue?vue&type=script&lang=js"
export * from "./Aba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports